import React from 'react'
import ReactDOM from 'react-dom'



/* Props 
    None
    Used for the top banner */
class Explainer extends React.Component {
    render() {
        return <div id="explainer_flex">
            <div className='explainer_block'><h4 className='explainer_title'>Step 1</h4> Create a room with your considered times</div>
            <div className='explainer_block'><h4 className='explainer_title'>Step 2</h4> Send an invite for the room so your guests can update their preferences</div>
            <div className='explainer_block'><h4 className='explainer_title'>Step 3</h4> Rank attendee importance for a particular event</div>
            <div className='explainer_block'><h4 className='explainer_title'>Step 4</h4> Click get results to get the best time</div>
        </div>

    }
}




export default Explainer